export enum QuestionContext {
  Onboarding = 'onBoarding',
  Profile = 'profile',
  Feedback = 'feedback',
  Role = 'role',
  Services = 'services',
  Moderator = 'moderator',
  Speaker = 'speaker',
  CrewMember = 'crew member',
}
